import { apiService } from "api/apiService";
import { currentUserFromDto } from "./auth.mapper";
import type { BadgeCounts, CurrentUser } from "./auth.types";

export const fetchCurrentUser = async (): Promise<CurrentUser> => {
  const {
    data: { data: currentUserData },
  } = await apiService.get(`/api/user/current`);

  return currentUserFromDto(currentUserData);
};

export const fetchBadgeCounts = async (): Promise<BadgeCounts> => {
  const { data } = await apiService.get<BadgeCounts>("/api/user/badge-counts");

  return data;
};
